define(function (require, exports, module) {
    'use strict';

    /**
     * @param {ArrayBuffer} arrayBuffer
     * @returns {string}
     */
    function convertArrayBufferToHexadecimalString(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var hexCode = '';

        for (var i = 0, length = dataView.byteLength; i < length; i++) {
            var hexValue = dataView.getUint8(i).toString(16);

            if (hexValue.length < 2) {
                hexValue = '0' + hexValue;
            }

            hexCode += hexValue;
        }

        hexCode = hexCode.toUpperCase();

        return hexCode;
    }

    module.exports = convertArrayBufferToHexadecimalString;
});
